var ajaxCalls = require('./ajaxCalls');
var QuestionController = require('./question_controller');


var timerLoop = function (exam,global) {
    global.elapsedTime++;
    if (global.ping-- < 0 ) {
        global.ping = 10;
        ajaxCalls.ping(global.userId,global.examId,global.elapsedTime,global.questionIndex,global.apiUrl);
    }
    switch(global.response.name) {
        case "Written":
            var remaining = 5400 - global.elapsedTime;
            break;
        case "Pathology":
            var remaining = 6600 - global.elapsedTime;
            break;
        case "Basic":
            var remaining = 14400 - global.elapsedTime;
            break;
        case "Core":
            var remaining = 7200 - global.elapsedTime;
            break;
        case "Applied":
            var remaining = 28800 - global.elapsedTime;
            break;
        default:
            var remaining = 14400 - global.elapsedTime;
    };
    if (remaining < 0 ) {
        clearInterval(global.timer);
        QuestionController.halt(exam,global);
    } else if ( remaining  < 301 ) {
        var time_string = remaining + ' seconds remaining';
    } else {
        var timeFormat = ' %d:%02d:%02d remaining';
        var hours = Math.floor(remaining/3600);
        var minutes = Math.floor((remaining - ( hours * 3600 )) / 60);
        var seconds = remaining - ( hours * 3600 ) - ( minutes * 60 );
        var time_string = sprintf(timeFormat, hours, minutes, seconds);
    }
    $(exam).find('.time-remaining').html(time_string);
}

module.exports = timerLoop;


//////////////////
// WEBPACK FOOTER
// ./src/timerloop.js
// module id = 316
// module chunks = 0